import { EventBus } from "@/components/toast/toastEventBus"

export const useToast = () => ({
    success: (msg, par) => EventBus.emit("ToastMessage", { tipo: "success", msg, par }),
    error: (msg, par) => (EventBus.emit("ToastMessage", { tipo: "error", msg, par })),
    info: (msg, par) => EventBus.emit("ToastMessage", { tipo: "info", msg, par }),
    alert: (msg, par) => EventBus.emit("ToastMessage", { tipo: "alert", msg, par }),
    close: () => EventBus.emit("ToastMessage", { tipo: "", msg: "" }),
})